import type { CategoryStat } from "../../types";

interface BarChartProps {
  categories: CategoryStat[];
}

function formatBaht(n: number) {
  return `฿${n.toLocaleString("en-US")}`;
}

export default function BarChart({ categories }: BarChartProps) {
  const max = Math.max(...categories.map((c) => c.amount));

  return (
    <div className="flex flex-col gap-2.5">
      {categories.map((cat) => (
        <div
          key={cat.category}
          className="grid items-center gap-3 grid-cols-[76px_1fr_auto] sm:grid-cols-[90px_1fr_auto]"
        >
          <div className="text-[12px] font-medium truncate text-foreground">
            {cat.label.split(" ")[0]}
          </div>
          <div className="relative rounded-full h-2.5 overflow-hidden bg-[var(--surface-muted)]">
            <div
              className="absolute inset-y-0 left-0 rounded-full transition-all duration-500"
              style={{
                width: `${(cat.amount / max) * 100}%`,
                background: cat.color,
              }}
            />
          </div>
          <div className="text-[12px] font-bold tabular-nums text-foreground">
            {formatBaht(cat.amount)}
          </div>
        </div>
      ))}
    </div>
  );
}
